var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"v2.268.0"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/checkout";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { SENTRY_ENABLED_ENVS } from './src/config/sentry.config';
const ROUTING_PREFIX = '/checkout';
if (SENTRY_ENABLED_ENVS.includes(process.env.NEXT_PUBLIC_APP_ENV)) {
  try {
    Sentry.init({
      dsn: `https://7e777f16b8b398134c243fd72cd49367@sentry-v2.clear.in//83`,
      tracesSampleRate: 1.0,
      tracePropagationTargets: ['localhost', /^https?:\/\/[^/]*cleartax/i],
      integrations: [
        Sentry.browserProfilingIntegration(),
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          blockAllMedia: false,
          maskAllText: false,
          maskAllInputs: false,
          maskAttributes: false,
          maxReplayDuration: 30000,
          networkDetailAllowUrls: [window.location.origin],
          networkRequestHeaders: ['Cache-Control'],
          networkResponseHeaders: ['Referrer-Policy'],
        }),
        Sentry.rewriteFramesIntegration({
          iteratee: (frame) => {
            if (
              frame.filename &&
              frame.filename.startsWith('app:///_next/static/')
            ) {
              frame.filename = `${ROUTING_PREFIX}${frame.filename.substring(
                6
              )}`;
            }
            return frame;
          },
        }),
      ],
      replaysOnErrorSampleRate: 1.0,
      environment: process.env.NEXT_PUBLIC_APP_ENV,
      release: process.env.NEXT_PUBLIC_RELEASE_VERSION || 'localhost',
      beforeSend(event) {
        event.extra = {
          ...event.extra,
          initiator: 'client',
        };
        return event;
      },
    });
  } catch (error) {
    console.error('Sentry initialization failed:', error);
  }
}
